import { useState, useEffect } from 'react'

const ScrollControls = () => {
  const [showControls, setShowControls] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      setShowControls(scrollTop > 300)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const scrollToBottom = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
  }

  if (!showControls) return null

  return (
    <div className="scroll-controls">
      <button className="scroll-btn" onClick={scrollToTop} title="回到顶部">
        ↑
      </button>
      <button className="scroll-btn" onClick={scrollToBottom} title="到底部">
        ↓
      </button>
    </div>
  )
}

export default ScrollControls
